/* eslint-disable no-redeclare */
/**
 * 加密盐混淆
 * @returns {Array} ['JfIR9RofenbQoTO','wsQ565RjVK0fGQfvxetzJJ8uRQ3mUwp6']
 */

export default (function (p, j) {
  var s = p.length
  var q = []
  for (var i = 0; i < s; i++) {
    q[i] = p.charAt(i)
  }
  for (var i = 0; i < s; i++) {
    var w = j * (i + 294) + (j % 23371)
    var l = j * (i + 448) + (j % 39769)
    var t = w % s
    var o = l % s
    var n = q[t]
    q[t] = q[o]
    q[o] = n
    j = (w + l) % 3859828
  }
  var g = String.fromCharCode(127)
  var x = ''
  var m = '\x25'
  var z = '\x23\x31'
  var a = '\x25'
  var b = '\x23\x30'
  var h = '\x23'
  return q
    .join(x)
    .split(m)
    .join(g)
    .split(z)
    .join(a)
    .split(b)
    .join(h)
    .split(g)
})('5nz85jmfJwb0eKU%QQuoV3xftp6fGwITRRvRQJe9R6JfOsQo', 1333658)
